export default function Impact() {
  const impacts = [
    {
      icon: 'ri-group-line',
      number: '150+',
      title: 'Famílias Beneficiadas',
      description: 'Agricultores familiares do Cariri paraibano que têm sua renda fortalecida através da caprinocultura leiteira'
    },
    {
      icon: 'ri-community-line',
      number: '10+',
      title: 'Associações Parceiras',
      description: 'Parcerias com associações de produtores e criadores de cabras da região, fortalecendo o cooperativismo'
    },
    {
      icon: 'ri-plant-line',
      number: '100%',
      title: 'Sustentabilidade',
      description: 'Produção sustentável que valoriza a agricultura familiar e preserva as tradições do semiárido brasileiro'
    },
    {
      icon: 'ri-heart-line',
      number: '20 Anos',
      title: 'Desenvolvimento Regional',
      description: 'Duas décadas contribuindo para o desenvolvimento econômico e social do Cariri paraibano'
    }
  ];

  return (
    <section id="impacto" className="py-8 md:py-20 bg-gradient-to-b from-green-50 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-6 md:mb-16">
          <h2 className="text-2xl md:text-5xl font-bold text-green-800 mb-3">Impacto Social</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto mb-3 md:mb-6"></div>
          <p className="text-sm md:text-xl text-gray-700 max-w-3xl mx-auto">
            Mais do que produzir queijos de qualidade, a Agubel transforma vidas e fortalece comunidades
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 max-w-7xl mx-auto mb-8 md:mb-16">
          {impacts.map((impact, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg shadow-lg p-4 md:p-8 text-center hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="w-14 h-14 md:w-20 md:h-20 bg-gradient-to-br from-green-600 to-green-700 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-6 shadow-lg">
                <i className={`${impact.icon} text-2xl md:text-4xl text-white`}></i>
              </div>
              <h3 className="text-xl md:text-3xl font-bold text-amber-600 mb-2 md:mb-3">{impact.number}</h3>
              <h4 className="text-sm md:text-xl font-bold text-green-800 mb-2 md:mb-3">{impact.title}</h4>
              <p className="text-xs md:text-base text-gray-700 leading-relaxed">{impact.description}</p>
            </div>
          ))}
        </div>
        
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden">
            <div className="grid md:grid-cols-2">
              <div className="relative h-64 md:h-auto">
                <img
                  src="https://static.readdy.ai/image/7511a7cc259ce621d354b0ff71fdfe7c/95346d102f829fd598cdd16732977d0d.jpeg"
                  alt="Agricultura Familiar"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              <div className="p-6 md:p-10 flex flex-col justify-center bg-gradient-to-br from-green-50 to-white">
                <h3 className="text-xl md:text-3xl font-bold text-green-800 mb-4 md:mb-6">Valorizando a Agricultura Familiar</h3>
                <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-4 md:mb-6">
                  A Agubel é mais do que um laticínio. Somos uma rede de cooperação que une produtores, fortalece comunidades e gera oportunidades para famílias do Cariri paraibano.
                </p>
                <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-4 md:mb-6">
                  Através de parcerias com associações locais, garantimos preços justos aos produtores, assistência técnica e acesso a mercados que valorizam a qualidade e a origem dos nossos produtos.
                </p>
                <div className="space-y-2 md:space-y-4">
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-lg md:text-2xl text-green-600 mr-2 md:mr-3 mt-1"></i>
                    <p className="text-xs md:text-base text-gray-700">Geração de renda para agricultores familiares</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-lg md:text-2xl text-green-600 mr-2 md:mr-3 mt-1"></i>
                    <p className="text-xs md:text-base text-gray-700">Fortalecimento do cooperativismo regional</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-lg md:text-2xl text-green-600 mr-2 md:mr-3 mt-1"></i>
                    <p className="text-xs md:text-base text-gray-700">Preservação das tradições do semiárido</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-lg md:text-2xl text-green-600 mr-2 md:mr-3 mt-1"></i>
                    <p className="text-xs md:text-base text-gray-700">Desenvolvimento sustentável da região</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
